import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import useParentSize from '../hooks/useParentSize'

/**
 * Placeholder to use in place of AlmaAd when ads are disabled
 */
const PlaceholderAd = ({ id, className }) => {
  const ref = useRef()
  const { width, height } = useParentSize(ref)

  return (
    <div className={ `ad-slot ad-slot--placeholder ${className}` }>
      <span ref={ ref }>{ id }<br />{ width }x{ height }</span>
    </div>
  )
}

PlaceholderAd.propTypes = exact({
  id: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
})

export default PlaceholderAd
